import React from 'react';
import Icon from 'react-web-vector-icons';
import './FloatingAddToCampaignBar.scss';

const FloatingAddToCampaignBar = ({ count, onAddToCampaign, position }) => {
	if (count === 0) return null;

	return (
		<div
			className="floating-add-campaign-bar"
			style={{
				top: position?.top || 'auto',
				left: position?.left || 'auto'
			}}
		>
			<div className="floating-bar-content" onClick={onAddToCampaign}>
				<Icon name="plus" font="AntDesign" color="#40A0C1" size={18} />
				<span className="floating-bar-text">
					Add to Campaign
				</span>
			</div>
		</div>
	);
};

export default FloatingAddToCampaignBar;
